import { makeStyles } from "@material-ui/styles";

const settingsDefinitionsStyles = makeStyles((theme) => ({
	sheet: {
		padding: theme.spacing(4)
	},
	sheetHeader: {
		borderBottom: "2px solid currentColor",
		paddingBottom: theme.spacing(1),
		marginBottom: theme.spacing(2)
	},
	sheetMeta: {
		marginTop: theme.spacing(0.5)
	},
	sheetSection: {
		marginTop: theme.spacing(2),
		// Keep a section's rows together when the sheet breaks across pages.
		breakInside: "avoid"
	},
	sheetSectionTitle: {
		textTransform: "uppercase",
		letterSpacing: "0.08em",
		borderBottom: "1px solid currentColor",
		paddingBottom: theme.spacing(0.5),
		marginBottom: theme.spacing(1)
	},
	sheetRow: {
		display: "grid",
		gridTemplateColumns: "200px 1fr",
		gap: theme.spacing(2),
		padding: theme.spacing(0.5, 0),
		breakInside: "avoid"
	},
	sheetTerm: {
		fontWeight: 600
	},
	// The value sits under its setting's name rather than in a third column:
	// a field-area set or a spot list is long, and a narrow middle column
	// would wrap it to several lines on every row.
	sheetValue: {
		color: theme.palette.text.secondary,
		wordBreak: "break-word"
	}
}));

export default settingsDefinitionsStyles;
